import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Pagination extends Component {
  static propTypes = {
    pagesQuantity: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    goToPageBtnIsShown: PropTypes.bool,
    decreasePage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired,
    increasePage: PropTypes.func.isRequired
  };
  render () {
    const { activePage, goToPageBtnIsShown, pagesQuantity, decreasePage, handlePageChange, goToPage, increasePage } = this.props;
    return (
      <div className='pagination'>
        <button className='button button-primary mr-3' onClick={decreasePage}>Previous</button>
        <input
          className='input input-short mr-3 text-center'
          type='number'
          value={activePage + 1}
          onChange={handlePageChange}
        />
        {goToPageBtnIsShown && (
          <button className='button button-primary mr-3' onClick={goToPage}>Go</button>
        )}
        <p className='mr-3'>page of {pagesQuantity}</p>
        <button className='button button-primary' onClick={increasePage}>Next</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ui/Pagination.js